<template>
	<div class="friendlink">

		<el-image class="banner-l pinter" @click="onPrev" :src='require("../static/index/leftslide@2x.png")' fit='cover'></el-image> 
    	<el-image class="banner-r pinter" @click="onNext" :src='require("../static/index/rightslide@2x.png")' fit='cover'></el-image> 

		<el-carousel loop indicator-position="none" arrow="never"
		 @change="changetab" height="160px" ref="img" >
			<el-carousel-item v-for="(items,index) in linkslist" :key="index">				
				<div class="friendcon">
					<div class="signlelink" v-for="(item,indey) in items" :key="indey" 
					@click="tonav(item.chainAddress)">
						<el-image class="img" fit='cover' :src="$imgUrl + item.logo_dictText" alt=""></el-image>
						<!-- <img class='img :src="$imgUrl + item.logo_dictText" alt=""/> -->
					</div>					
				</div>				
			</el-carousel-item>
		</el-carousel>
		
	</div>
	
</template>

<script>


export default {
 
  data: function() {
    return {
		signindex:0,
		linkslist:[],
	  
    };
  },
  
  mounted() {
		this.getLinks()
  },
  
  methods: {
	onPrev(){
      this.$refs.img.prev()
    }, 
    onNext(){
      this.$refs.img.next()
    },
    changetab(e){
     	// console.log(e)
     	this.signindex = e
    },
	
	tonav(link) {
		window.open(link);
	},
	
	//获取友情链接
	getLinks(){
		var that = this;
		this.$get(`web/externallink/ypExternalLink/list`).then(res=>{
			  if(res.success){
					// this.linkslist = res.result
					var list = [];
					var ifwhole = false
					if(res.result.length%4 == 0){
						ifwhole = true
					}
					var len = res.result.length;
					
					res.result.forEach(function(val,key,arr){
					    // console.log(val,key,arr);	
						list.push(val);
						if((key+1)%4 == 0){
							that.linkslist.push(list);
							list = [];
						}
						if(!ifwhole){
							if(key+1 == len){
								that.linkslist.push(list);
							}
						}	
						
					})
					
					// console.log(this.linkslist)
			  }
		})
	},
	
	
  },
  
  
};
</script>

<style scoped=" scoped" lang="scss">
	
.friendlink{
	position: relative;
	.banner-l,.banner-r{
		position: absolute;
		top: calc(50% - 10px);
		width: 20px;
		height: 20px;
	}
	.banner-l{
		left: -25px!important;
	}
	.banner-r{
		right: -25px!important;
	}
	.friendcon{
		display: flex;
		align-items: center;
		margin-top: 40px;
		.signlelink{
			margin-right: 40px;
			width: calc(25% - 30px);
			.img{
				cursor: pointer;
				border: 1px solid #ededed;
				width: 100%;
				height:74px;
			}
		}
		.signlelink:last-child{ 
			margin-right: 0px;
		}
	}
	
	
	
	
}

</style>
